import { create } from 'zustand'
import { CheckInDateType, PlanType } from '../components/landing-page/availability-tab/type'

interface PlanStore {
  isShowCheckInDateAlert: boolean
  setIsShowCheckInDateAlert: (isShowCheckInDateAlert: boolean) => void

  selectedPlan: PlanType | null
  setSelectedPlan: (plan: PlanType | null) => void

  selectedCheckInDate: CheckInDateType | null
  setSelectedCheckInDate: (checkInDate: CheckInDateType | null) => void

  validationErrors: {
    childBirthdate: boolean
    minChildren: boolean
  }
  setValidationErrors: (errors: any) => void
  openModalFilter: boolean
  setOpenModalFilter: (openModalFilter: boolean) => void
}

export const usePlanStore = create<PlanStore>()((set) => ({
  isShowCheckInDateAlert: false,
  setIsShowCheckInDateAlert: (value: boolean) => set((_state) => ({ isShowCheckInDateAlert: value })),

  selectedPlan: null,
  setSelectedPlan: (plan: PlanType | null) => set((_state) => ({ selectedPlan: plan })),

  selectedCheckInDate: null,
  setSelectedCheckInDate: (checkInDate: CheckInDateType | null) => set((_state) => ({ selectedCheckInDate: checkInDate })),

  validationErrors: {
    childBirthdate: false,
    minChildren: false,
  },
  setValidationErrors: (errors: any) => set((_state) => ({ validationErrors: errors })),
  openModalFilter: false,
  setOpenModalFilter: (value: boolean) => set((_state) => ({ openModalFilter: value })),
}))
